/* [PATCH nastavitve-zavihki v1] preseljeno 1:1 iz ProfilPage.tsx:
   helperja ppVrednost/ppNastavi (101-108) + JSX (430-464), samo za eno smer.
   [PATCH interne-predpone v1] predpone internih stevilk (companies.interne_predpone).
   Vrednost '' = ni predpone; ppOdprti drzi vrstice, kjer je uporabnik odprl vnos,
   a se ni nic vpisal (prazna vrednost sama po sebi ne sme drzati polja odprtega). */
import React, { useState } from 'react';
import { Hash } from 'lucide-react';

export function PredponeKartica({ smer, data, set }: {
  smer: 'prejeti' | 'izdani';
  data: any;
  set: (field: string, value: any) => void;
}) {
  const [ppOdprti, setPpOdprti] = useState<Record<string, boolean>>({});

  const ppVrednost = (smer: string, vrsta: string): string =>
    String((((data?.interne_predpone || {})[smer]) || {})[vrsta] || '');
  const ppNastavi = (smer: string, vrsta: string, v: string) => {
    const cfg = { ...(data?.interne_predpone || {}) };
    cfg[smer] = { ...(cfg[smer] || {}), [vrsta]: v };
    set('interne_predpone', cfg);
  };

  const naslov = smer === 'prejeti'
    ? 'Predpone internih številk — prejeti računi'
    : 'Predpone internih številk — izdani računi';

  return (
    <div className="rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-5">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-xl bg-blue-50 dark:bg-blue-900/30 text-blue-600 flex items-center justify-center">
          <Hash className="w-5 h-5" />
        </div>
        <div>
          <h2 className="font-semibold text-gray-900 dark:text-white">{naslov}</h2>
          <p className="text-xs text-gray-500">Predpona pred zaporedno interno številko, ločeno po vrsti dokumenta.</p>
        </div>
      </div>
      <div className="mt-4 space-y-2">
        {/* [PATCH gotovinski-predpona v1] vrstica Gotovinski samo pri izdanih */}
        {([['racun', 'Računi'], ['dobropis', 'Dobropisi'], ['avans', 'Avansi'], ...(smer === 'izdani' ? [['gotovinski', 'Gotovinski']] : [])] as [string, string][]).map(([vrsta, naslovVrste]) => {
          const kljuc = `${smer}.${vrsta}`;
          const v = ppVrednost(smer, vrsta);
          const odprt = !!v || !!ppOdprti[kljuc];
          return (
            <div key={vrsta} className="flex items-center gap-2">
              <label className="w-20 shrink-0 text-xs font-medium text-gray-500 dark:text-gray-400">{naslovVrste}</label>
              {odprt ? (
                <>
                  {/* [PATCH izdani-interna-originalna v1] maxLength 14: zeton {LL} steje 4 znake vnosa, razsirjen 2 */}
                  <input value={v} maxLength={14} placeholder="npr. A ali {LL}" autoFocus={!v}
                    onChange={(e) => ppNastavi(smer, vrsta, e.target.value)}
                    className="w-24 px-2 py-1 text-sm font-mono rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white" />
                  <button type="button" title="Odstrani predpono"
                    onClick={() => { ppNastavi(smer, vrsta, ''); setPpOdprti(p => ({ ...p, [kljuc]: false })); }}
                    className="px-2 py-1 text-sm text-gray-400 hover:text-red-500">×</button>
                </>
              ) : (
                <button type="button"
                  onClick={() => setPpOdprti(p => ({ ...p, [kljuc]: true }))}
                  className="text-xs text-blue-600 dark:text-blue-400 hover:underline">+ Dodaj predpono</button>
              )}
            </div>
          );
        })}
      </div>
      <p className="mt-4 text-xs text-gray-500 dark:text-gray-400">Predpona velja za dokumente, potrjene od zdaj naprej. Obstoječe interne številke se ne spremenijo. Če dve vrsti uporabljata isto predpono, si delita zaporedje.{' '}
        {/* [PATCH izdani-interna-originalna v1] */}
        Žeton <span className="font-mono">{'{LL}'}</span> = zadnji dve števki leta (npr. <span className="font-mono">{'{LL}'}SKL</span> → <span className="font-mono">26SKL</span>). Pri izdanih z originalno številko se predpona doda pred številko računa.
        {/* [PATCH gotovinski-predpona v1] */}{smer === 'izdani' && ' Gotovinski = davčno potrjeni računi (gotovina, kartica); brez predpone se številčijo kot računi.'}</p>
    </div>
  );
}
